export function CitrusSlice() {
  const segments = Array.from({ length: 10 }, (_, index) => index * 18 - 81);
  return <svg className="citrus-slice" viewBox="0 0 420 420" aria-hidden="true">
    <g transform="translate(12 408)">
      <circle r="294" fill="none" stroke="#ff9a45" strokeWidth="28" />
      <circle r="264" fill="none" stroke="#f4e7c5" strokeWidth="8" opacity=".75" />
      {segments.map((angle) => <path key={angle} d="M0 0 L-34 -248 A250 250 0 0 1 34 -248 Z" fill="#f47728" fillOpacity=".82" stroke="#ffd29d" strokeWidth="5" transform={`rotate(${angle})`} />)}
      <circle r="34" fill="#f4e7c5" opacity=".82" />
    </g>
  </svg>;
}
